interface MapGISToolsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onCenter: () => void;
  onToggleFullscreen: () => void;
  fullscreen: boolean;
  onMyLocation: () => void;
  locating: boolean;
}

interface ToolButtonProps {
  icon: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

function ToolButton({ icon, label, onClick, disabled }: ToolButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="w-10 h-10 bg-white/95 backdrop-blur-sm border border-background-200/70 rounded-lg flex items-center justify-center hover:bg-background-50 transition-colors shadow-sm group relative disabled:opacity-60"
    >
      <i className={`${icon} text-foreground-600 text-base`} aria-hidden="true"></i>
      <span className="absolute left-full ml-2 px-2 py-1 bg-foreground-900 text-white text-[10px] rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
        {label}
      </span>
    </button>
  );
}

/**
 * Ferramentas do mapa.  So fica o que funciona de verdade: medicao, desenho, selecao por area e
 * agrupamento eram botoes sem acao e foram retirados (o Console de Edicao Territorial tem medicao e desenho).
 */
export default function MapGISTools({
  onZoomIn, onZoomOut, onCenter, onToggleFullscreen, fullscreen, onMyLocation, locating,
}: MapGISToolsProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <ToolButton icon="ri-focus-3-line" label="Centralizar nos exemplares" onClick={onCenter} />
      <ToolButton
        icon={fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line"}
        label={fullscreen ? "Sair da tela cheia" : "Tela cheia"}
        onClick={onToggleFullscreen}
      />
      <ToolButton
        icon={locating ? "ri-loader-4-line animate-spin" : "ri-user-location-line"}
        label="Minha localização"
        onClick={onMyLocation}
        disabled={locating}
      />
      <div className="h-1.5" aria-hidden="true" />
      <ToolButton icon="ri-add-line" label="Aproximar" onClick={onZoomIn} />
      <ToolButton icon="ri-subtract-line" label="Afastar" onClick={onZoomOut} />
    </div>
  );
}
